import React, { ReactNode } from "react";

import UploadBriefButton from "src/app/components/UploadBriefButton/UploadBriefButton";
import { SkeletonRect } from "src/app/components/Skeleton/Skeleton";
import FilePreview from "../FilePreview/FilePreview";

import "./FilePreviewDisplay.scss";

interface FilePreviewDisplayProps {
  isLoading: boolean;
  fileName?: string;
  shouldDisplayPreview: boolean;
  fileNameMaxWidth?: number;
  onOpenPreview: () => void;
  label: ReactNode;
}

export default function FilePreviewDisplay({
  isLoading,
  fileName,
  shouldDisplayPreview,
  fileNameMaxWidth,
  onOpenPreview,
  label,
}: FilePreviewDisplayProps) {
  const renderContent = () => {
    if (isLoading) {
      return <SkeletonRect width={100} height={20} />;
    }

    if (shouldDisplayPreview) {
      return (
        <FilePreview
          fileName={fileName}
          onClick={onOpenPreview}
          fileNameMaxWidth={fileNameMaxWidth}
        />
      );
    }

    return <UploadBriefButton onClick={onOpenPreview} />;
  };

  return (
    <div className="file-preview-display">
      <span className="text-body-medium">{label}</span>
      {renderContent()}
    </div>
  );
}
